export default "__VITE_ASSET__TK07OSp8__"